module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clare Connelly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Clare Connelly")]), _vm._v(" was raised in small-town Australia among a family of avid readers. She spent much of her childhood up a tree, Harlequin book in hand. She is married to her own real-life hero in a bungalow near the sea with their two children. She is frequently found staring into space - a surefire sign she is in the world of her characters. Writing for Harlequin Presents is a long-held dream. Clare can be contacted via clareconnelly.com or on her Facebook page.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iDIU5E/tc-custom/9781488044403.jpg?1708087307410",
      "alt": "This image is the cover for the book Spaniard's Baby of Revenge"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Spaniard's Baby of Revenge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Though their families are feuding, a one night stand leads to pregnancy and a marriage of convenience in this sexy enemies to lovers international romance.")]), _c('br'), _c('br'), _vm._v("His vengeance was strictly business . . . "), _c('br'), _c('br'), _vm._v("Until he discovers she’s carrying his heir!"), _c('br'), _c('br'), _vm._v("Antonio Herrera’s plan is simple: persuade innocent Amelia diSalvo to sell the shares in his rival’s business. But what the Spanish billionaire didn’t plan on was their intense connection. Now Antonio has only one aim . . . the ultimate seduction! So he’s stunned to discover their nine-month consequence. To secure his heir, he’ll do the unthinkable—and shockingly pleasurable—and make Amelia his wife!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0